var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120.12 120.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y2: 44.499,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 80.573,
    gradientTransform: "matrix(1.0293 0 0 .97158 -2.96 -25.676)",
    x2: 45.269,
    x1: 39.586
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 53.201,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 37.035,
    gradientTransform: "matrix(.75711 0 0 1.3208 -2.96 -25.676)",
    x2: 100.76,
    x1: 130.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y2: 118.53,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 106.15,
    gradientTransform: "matrix(1.1732 0 0 .85239 -2.96 -25.676)",
    x2: 75.429,
    x1: 63.331
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y2: 82.828,
    gradientUnits: "userSpaceOnUse",
    y1: 51.665,
    gradientTransform: "scale(1.2005 .83296)",
    x2: 105.51,
    x1: -2.654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    fx: 28.849,
    fy: 35.508,
    gradientUnits: "userSpaceOnUse",
    cy: 34.355,
    cx: 30.19,
    gradientTransform: "matrix(.9172 0 0 1.0903 -2.96 -25.676)",
    r: 36.881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    fx: 28.293,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    cy: 61.519,
    cx: 28.74,
    gradientTransform: "scale(1.2119 .82517)",
    r: 41.548
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    fx: 42.999,
    fy: 101.38,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    cy: 100.44,
    cx: 43.251,
    gradientTransform: "scale(1.3783 .72553)",
    r: 30.255
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    fx: 29.636,
    fy: 66.082,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    cy: 66.472,
    cx: 29.951,
    gradientTransform: "scale(1.6162 .61875)",
    r: 20.205
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.305 2.227c-22.858-.66-25.246 24.69-25.246 38.831l.666 46.566 47.855-12.21c.98-8.243.01-33.142.01-34.356 0-14.142-4.02-38.17-23.285-38.83z",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.75,
    fill: "#ffc800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.249 2.568c-22.858-.66-25.246 24.69-25.246 38.831l.666 46.565 47.851-12.21c.98-8.242.02-33.14.02-34.355 0-14.142-4.02-38.172-23.291-38.83z",
    fillRule: "evenodd",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.34 75.494C77.202 58.783 67.735 57.903 54.675 52.405c.545 13.305-.217 22.979.327 34.639 20.677-4.18 23.398-6.38 47.338-11.55z",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.75,
    fill: "#ffc800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.67 75.994C77.529 59.278 68.061 58.398 55.002 52.9c.544 13.305-.218 22.984.326 34.634 20.677-4.18 23.398-6.37 47.342-11.54z",
    fillRule: "evenodd",
    fill: "url(#d)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.78425 .13808 -.125 .81324 36.077 -9.4)",
    d: "M29.29 32.227A20.04 20.04 0 009.206 52.31v32.069A20.038 20.038 0 0029.29 104.46h63.938a20.04 20.04 0 0020.082-20.081V52.31a20.04 20.04 0 00-20.083-20.083H29.29z",
    strokeLinejoin: "round",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.75,
    fill: "#ffc800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.128 31.749a20.039 20.039 0 00-20.083 20.083v32.07a20.035 20.035 0 0020.083 20.078h63.938a20.037 20.037 0 0020.084-20.078v-32.07a20.041 20.041 0 00-20.084-20.083H33.128z",
    fill: "url(#e)",
    transform: "matrix(.78425 .13808 -.125 .81324 33.457 -8.84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.375 34.156C17.455 36.091 12.413 47.926 14 58.031c.856 11.222-1.957 23.126 1.938 33.852C20.77 103.02 34.123 102.45 44.281 102c18.785-.44 37.746.88 56.419-.68 10.95-2.46 14.89-14.601 13.42-24.601-.96-11.179 2.29-23.266-2.41-33.762-6.15-11.848-20.892-8.929-31.866-9.207-17.146.257-34.36-.523-51.469.406z",
    fill: "url(#f)",
    transform: "matrix(.78425 .13808 -.125 .81324 33.457 -8.84)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.78425 .13808 -.125 .81324 36.077 -9.4)",
    d: "M16.997 99.505c15.186-14.242 28.012-28.957 43.199-43.2C77.114 69.84 90.255 85.499 107.17 99.033c-1.33 1.577-5.74 5.747-10.384 5.667-23.528.16-44.459-.16-67.986 0-4.171-.32-9.994-1.58-11.803-5.195z",
    strokeLinejoin: "round",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.75,
    fill: "#ffc800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.969 66.531C43.768 76.946 33.681 87.585 23.125 97.688c9.106 5.742 20.804 2.03 31.031 3.092 16.214-.34 32.553.69 48.684-.53 9.09-2.648-1.08-7.423-4.405-10.988-11.646-10.665-22.591-22.098-34.779-32.168l-9.687 9.437z",
    fill: "url(#g)",
    transform: "matrix(.78425 .13808 -.125 .81324 33.457 -8.84)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.78425 .13808 -.125 .81324 36.077 -9.4)",
    d: "M17.941 37.892C31.79 47.965 44.931 57.328 58.78 67.4c15.187-10.308 31.082-19.908 46.27-30.216-2.01-6.255-17.844-4.877-45.444-4.957-30.292-.089-40.603-1.534-41.665 5.665z",
    strokeLinejoin: "round",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.75,
    fill: "#ffc800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.719 31c-8.419-.367-8.115 4.738-1.046 7.527l31.983 23.098L103 33.312c-11.75-4.289-24.821-1.703-37.125-2.424-12.387.07-24.772-.344-37.156.112z",
    fill: "url(#h)",
    transform: "matrix(.78425 .13808 -.125 .81324 33.457 -8.84)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.05 86.634c-17.925-2.45-34.218-10.83-51.491-21.197-1.139-8.826-9.164-54.27 23.583-59.839 21.114-1.843 57.754-8.534 64.404 2.988C80.295-2.8 69.921 2.538 63.315 8.25c-13.248 11.455-8.379 51.964-8.265 78.384z",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.75,
    fill: "#ffc800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.221 86.334c-17.925-2.45-34.218-10.83-51.491-21.199-1.138-8.827-9.164-54.27 23.583-59.84 21.114-1.843 57.754-8.534 64.404 2.988-9.292-8.416-22.809-2.114-29.537.984-7.143 3.289-7.072 50.645-6.959 77.067z",
    fillRule: "evenodd",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.012 5.225c-12.5 1.442-28.269.71-35.497 13.38-8.035 13.59-6.422 30.261-4.575 45.3 14.967 8.723 30.619 17.24 47.851 20.13.453-23.093-.959-46.605 3.884-69.297.613-7.42 8.491-9.449 14.413-11.09-8.724-.258-17.383 1.02-26.076 1.577z",
    fillRule: "evenodd",
    fill: "url(#j)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.c8bdd154bb00256562e6bfba445c0a51.svg";
export { ForwardRef as ReactComponent };